import {Component, Input, OnInit} from '@angular/core';
import {Environment} from '../environment/environment';
import {MaintenanceModeConfig} from '../../model/maintenance-config/maintenance-mode-config';
import {MaintenanceService} from '../../services/maintenance/maintenance-service';
import {OcapiService} from '../../services/ocapi/ocapi.service';
import {Observable} from 'rxjs';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';
import { productTypeRendition, ProductTypeRenditionEnum } from '../../constants/renditions/product-type-rendition.constants';

@Component({
  selector: 'app-tvshop-header',
  templateUrl: './tvshop-header.component.html',
  styleUrls: ['./tvshop-header.component.less']
})
export class TvshopHeaderComponent implements OnInit {
  @Input() titleKey: string;
  @Input() rendition: productTypeRendition;
  StreamingBundleProductTypeRendition = ProductTypeRenditionEnum.streamingBundle;
  clockTime: Date = new Date();
  currentBrowserAddress: string;
  isThereMaintenancePlanned: boolean;
  maintenanceModeConfig: MaintenanceModeConfig;
  showTvShopHeader = true;

  constructor(private maintenanceService: MaintenanceService,
              public ocapiService: OcapiService,
              private stateService: TvShopStateService) {
  }

  ngOnInit() {
    this.utcTime();
    this.currentBrowserAddress = window.location.href;
    this.maintenanceService.getMaintenanceMode().subscribe(config => {
      this.maintenanceModeConfig = config;
      this.isThereMaintenancePlanned = config.isPlanned();
    });
    this.stateService.isTrailerPlaying$.subscribe((trailerPlaying) => {
      this.showTvShopHeader = !trailerPlaying;
    });
  }

  utcTime(): void {
    setInterval(() => {
      this.clockTime = new Date();
    }, 1000);
  }

  get shouldDisplayCurrentBrowserAddress(): boolean {
    return 'dvp' === Environment.getCurrentEnvironment()
      || 'edp' === Environment.getCurrentEnvironment()
      || 'uat' === Environment.getCurrentEnvironment()
      || 'local' === Environment.getCurrentEnvironment()
      ;
  }

  get currentDtvIdentifier(): Observable<string> {
    return this.ocapiService.getDtvIdentifier();
  }

  get currentCustomer(): Observable<string> {
    return this.ocapiService.getCustomerNumber();
  }
}
